import { TranslationKey } from 'src/app/core/services/translater';

export const formValidationCommonErrorsMap = new Map<string, TranslationKey>([
  ['required', 'COMMON.VALIDATION_ERRORS.REQUIRED'],
  ['pattern', 'COMMON.VALIDATION_ERRORS.PATTERN'],
  ['unvalidDateRangeStart', 'COMMON.VALIDATION_ERRORS.UNVALID_RANGE_START_END'],
  ['unvalidDateRangeEnd', 'COMMON.VALIDATION_ERRORS.UNVALID_RANGE_END_START'],
  ['notEmptyString', 'COMMON.VALIDATION_ERRORS.NOT_EMPTY_STRING'],
  ['nonEmptyArray', 'COMMON.VALIDATION_ERRORS.NOT_EMPTY_ARRAY'],
  ['registerNumber', 'COMMON.VALIDATION_ERRORS.REGISTER_NUMBER'],
  ['dateInThePast', 'COMMON.VALIDATION_ERRORS.DATE_IN_PAST'],
  ['dateInTheFuture', 'COMMON.VALIDATION_ERRORS.DATE_IN_FUTURE'],
  ['positive', 'COMMON.VALIDATION_ERRORS.POSITIVE'],
]);
